import { isNumber, isObject, isUndefined } from "lodash"

export interface IOptions
{
	name: string,
	value: number
}

export default class OptionsController
{
	public lista_tipoSerie = [
		{name: 'Vídeo', value: 1},
		{name: 'Podcast', value: 2},
		{name: 'Eventos', value: 3},
		{name: 'Streaming', value: 4}
	] as IOptions[]

	public lista_classificacaoEtaria = [
		{name: 'Livre', value: 0},
		{name: '10 Anos', value: 10},
		{name: '12 Anos', value: 12},
		{name: '14 Anos', value: 14},
		{name: '16 Anos', value: 16},
		{name: '18 Anos', value: 18},
	] as IOptions[]

	public lista_tipoPrograma = [
		{name: 'Episódio de série', value: 1},
		{name: 'Programa único', value: 2},
	] as IOptions[]

	public lista_tipoMidia = [
		{name: 'Base limpa', value: 1},
		{name: 'Vídeo original', value: 2},
		{name: 'Áudio original', value: 3},
		{name: 'Base limpa com vídeo', value: 4},
	] as IOptions[]	

	public lista_vigencia = [
		{name: 'Prazo determinado', value: 1},
		{name: 'Número de exibições', value: 2},
		{name: 'Ambos', value: 3},
	] as IOptions[]

	public lista_licenciamento = [
		{name: 'Sim', value: 1},
		{name: 'Não', value: 2},
		{name: 'Com restrições', value: 3},
	] as IOptions[]

	public lista_versao = [
		{name: 'Dublada', value: 1},
		{name: 'Legendada', value: 2},
	] as IOptions[]

	public lista_idiomaVersao = [
		{name: 'Inglês', value: 1},
		{name: 'Espanhol', value: 2},
		{name: 'Francês', value: 3},
		{name: 'N/A', value: 9}
	] as IOptions[]

	tipoSerie(): IOptions[]
	{
		return this.lista_tipoSerie;
	}
	nomeSerie(val:any): string
	{
		return (isNumber(val) ? this.lista_tipoSerie.find(item => item.value === val)?.name : "");
	}

	classificacaoEtaria(): IOptions[]
	{
		return this.lista_classificacaoEtaria;
	}
	nomeClassificacaoEtaria(val:any): string
	{
		return (isNumber(val) ? this.lista_classificacaoEtaria.find(item => item.value === val)?.name : "");
	}

	tipoPrograma(): IOptions[]
	{
		return this.lista_tipoPrograma;
	}
	nomeTipoPrograma(val:any): string
	{
		return (isNumber(val) ? this.lista_tipoPrograma.find(item => item.value === val)?.name : "");
	}

	tipoMidia(): IOptions[]
	{
		return this.lista_tipoMidia;
	}
	nomeTipoMidia(val:any): string
	{
		return (isNumber(val) ? this.lista_tipoMidia.find(item => item.value === val)?.name : "");
	}

	vigencia(): IOptions[]
	{
		return this.lista_vigencia;
	}
	nomeVigencia(val:any): string
	{
		return (isNumber(val) ? this.lista_vigencia.find(item => item.value === val)?.name : "");
	}

	licenciamento(): IOptions[]
	{
		return this.lista_licenciamento;
	}
	nomeLicenciamento(val:any): string
	{
		return (isNumber(val) ? this.lista_licenciamento.find(item => item.value === val)?.name : "");
	}

	versao(): IOptions[]
	{
		return this.lista_versao;
	}
	nomeVersao(val:any): string
	{
		return (isNumber(val) ? this.lista_versao.find(item => item.value === val)?.name : "");
	}

	idiomaVersao(): IOptions[]
	{
		return this.lista_idiomaVersao;
	}
	nomeIdiomaVersao(val:any): string
	{
		return (isNumber(val) ? this.lista_idiomaVersao.find(item => item.value === val)?.name : "");
	}
}